<auth-template>
  <div class="content-container">
    @if ((requestSuccess$ | async) === false) {
      <button
        mat-button
        class="ficon-arrow-left btn-none back-btn"
        role="button"
        [attr.aria-label]="'common_back' | translate"
        (click)="navigateBack()">
      </button>
    }
    <div class="content-space">
      @if ((requestSuccess$ | async) === false) {
        <form
          (ngSubmit)="submit(form)"
          [formGroup]="form">
          <h4 translate="forgot-password_title" class="header"></h4>
          <p translate="forgot-password-reset_paragraph_text" class="description"></p>
          <div class="form-section">
            <div>
              <mat-form-field appearance="outline">
                <mat-label translate="forgot-password_label"></mat-label>
                <input matInput
                  formControlName="email"
                  type="email"
                  class="fullstory-ignore"
                  [attr.aria-label]="'email' | translate"/>
                @if (form.controls.email.hasError('required')) {
                  <mat-error translate="login-form_validation-email-required"></mat-error>
                }
                @if (form.controls.email.hasError('email')) {
                  <mat-error translate="login-form_validation-email-invalid"></mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          <div class="form-section action-section">
            <button
              type="submit"
              class="primary-btn submit-btn"
              [attr.aria-label]="'forgot-password-button_send' | translate"
              [disabled]="disableRequestPasswordButton() || (disableButton$ | async)">
              @if (loading$ | async) {
                <i class="ficon-spinner ficon-spin"></i>
              }
              <span translate="forgot-password-button_send"></span>
            </button>
            @if ((resetLockDuration$ | async); as lockDuration) {
              <div class="form-message remaining-lock-message">
                @if (lockDuration > 0) {
                  {{ getResendDurationMessage(lockDuration) }}
                }
              </div>
            }
            @if ((requestError$ | async)) {
              <div class="form-message unknown-error"
                translate="unknown-error-description">
              </div>
            }
          </div>
        </form>
      }

      @if (requestSuccess$ | async) {
        <div class="forgot-password-success">
          <h4 translate="forgot-password-request-sent_title" class="header"></h4>
          <div class="description">
            {{'forgot-password-request-sent_email_sent' | translate}} {{'forgot-password-request-sent_check_inbox' | translate}}
          </div>
          <div class="button-container action-section">
            <button
              type="button"
              class="primary-btn close-btn"
              [attr.aria-label]="'forgot-password_go-to-login' | translate"
              (click)="navigateBack()">
              @if (loading$ | async) {
                <i class="ficon-spinner ficon-spin"></i>
              }
              <span translate="forgot-password-request-sent_close_btn"></span>
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</auth-template>
